<template>
  <v-card flat :style="`height: ${ windowSize.y }px; position: 'relative'`" class="pa-1 product-view" v-resize="onResizeHandler">
    <div class="text-center" v-if="loading">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-card-text class="pa-0">
      <v-form ref="receiveForm" v-on:submit.prevent>
        <v-row>
          <v-col cols="12" class="pb-0 pt-0 font-weight-bold">{{ orderModel.number }}</v-col>
          <v-col cols="12" class="pb-0 pt-0 font-weight-bold">{{ orderModel.warehouse_name }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pt-0 pr-1 pb-0 mt-1">
            <v-text-field outlined dense hide-details v-model="scanProduct" flat autocomplete="off"
              ref="scanProduct" @change="getRespectiveProductOrder" :loading="productLoading"
            :placeholder="$t('message.order.scanProduct')"></v-text-field>
          </v-col>
          <v-col cols="12" class="pt-1 pb-1 font-weight-bold" v-if="productFound">
            <span v-if="!isNewProduct">{{ productInfo.productname || '' }}</span>
            <span v-else class="red--text">{{ productInfo.name || '' }}</span>
          </v-col>
          <v-row v-if="productFound">
            <v-col cols="12" class="pa-0 pl-6 pr-5">
              <v-text-field outlined dense hide-details v-model="selectedLocation" flat autocomplete="off"
                  :rules="$_requiredValidation" @change="checkIfLocationValid" :loading="loadingLocation"
                  ref="scanLocation" :placeholder="$t('message.product.scanLoc')"></v-text-field>
            </v-col>
          </v-row>
          <template v-if="productFound && productInfo.isbatch">
            <v-col cols="8" class="pt-0 pb-0" :class="$vuetify.breakpoint.width < 759 ? 'mt-2' : ''">
              <v-text-field outlined dense hide-details v-model="selectBatch" flat autocomplete="off"
              :rules="$_requiredValidation" :placeholder="$t('message.product.batch')" ref="batchRef"
              :loading="loadingBatch" @change="checkIfBatchContainsQty"></v-text-field>
            </v-col>
          </template>
        </v-row>
        <v-row v-if="productFound">
          <v-col cols="8" class="pa-1 text-right">
            <v-row>
              <v-col cols="3" class="text-center pa-0" @click="decreaseQty" v-if="isNewProduct">
                <v-btn color="info" fab x-small>
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="6" class="pa-0" :class="isNewProduct ? '' : 'ml-5'">
                <v-text-field outlined dense hide-details type="number" class="text-right" v-model="pickQty" :disabled="!isNewProduct"
                  autocomplete="off" ref="qtyRef" :rules="$_norwegianNumberMinusValidation" :placeholder="$t('message.product.qty')"></v-text-field>
              </v-col>
              <v-col cols="3" class="text-center pa-0" @click="increaseQty" v-if="isNewProduct">
                <v-btn color="info" fab x-small>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4" class="pa-1 mt-1 text-center">
            <v-btn color="primary" dark small :loading="saveLoading" @click="receiveQtyOnOrder">
              {{ $t('message.order.adjust') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <!-- LIST OF PRODUCTS -->
    <v-card-text class="highlight pt-0 pb-0 pl-1 mt-2">
      <v-row>
        <v-col cols="6" class="pa-0 pl-3 font-weight-bold">{{ $t('message.dashboard.product') }}:</v-col>
        <v-col cols="3" class="pa-0 pr-2 text-center font-weight-bold">{{ $t('message.ccsheet.unit') }}</v-col>
        <v-col cols="3" class="pa-0 text-right font-weight-bold">{{ $t('message.order.ordered') }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-divider class="pa-0"></v-divider>
        </v-col>
      </v-row>
      <!-- Load list of products -->
      <v-row v-for="(product, index) in listOfProducts" :key="index">
        <v-col cols="6" class="pa-0 pl-3 text-truncate" :title="product.productnumber" :class="{ 'pb-1': (index === listOfProducts.length - 1)}">
          {{ product.productnumber }}
          <br />
          <span>{{ product.productname }}</span>
        </v-col>
        <v-col cols="3" class="pa-0 text-center text-truncate" :title="product.unitname">{{ product.unitname }}</v-col>
        <v-col cols="3" class="pa-0 text-right text-truncate">{{ product.qty | absoluteNumber }}</v-col>
      </v-row>
    </v-card-text>
    <v-btn color="primary" dark absolute bottom left tabindex="-1" @click="$router.push(`/adjustment_orders/${orderId}`)">
      <v-icon left>mdi-arrow-left-bold</v-icon>{{ $t('message.login.back') }}
    </v-btn>
    <v-btn color="primary" dark absolute bottom right tabindex="-1" @click="completeDialog = true">
      {{ $t('message.order.complete') }}
    </v-btn>
    <v-dialog v-model="completeDialog" persistent class="mt-0">
      <v-card>
        <v-card-title class="pa-2">
          {{ $t('message.ccsheet.info') }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-2">
          <h4>{{ $t('message.order.orderComplete') }}</h4>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" small :loading="completeLoading" @click="completeAdjustmentOrder">{{ $t('message.common.yes') }}</v-btn>
          <v-btn color="success" small @click="completeDialog = false">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      orderId: 0,
      listOfProducts: [],
      orderModel: {},
      scanProduct: '',
      windowSize: {
        x: 0,
        y: 0
      },
      productFound: false,
      productInfo: {},
      pickQty: '',
      listOfLocations: [],
      selectedLocation: '',
      selectedLocationId: 0,
      selectBatch: '',
      saveLoading: false,
      loadingBatch: false,
      productLoading: false,
      loadingLocation: false,
      completeDialog: false,
      completeLoading: false
    }
  },
  mounted () {
    this.loading = true
    this.orderId = this.$route.params.order_id
    this.getOrderProducts()
    this.getOrderInfo()
    this.onResizeHandler()
    this.focusField('scanProduct')
  },
  watch: {
    pickQty (val) {
      // let pickedQty = parseFloat(this.$format.replaceCommaWithDot(val || 0))
      // let products = this.$format.cloneVariable(this.listOfProducts)
      // let getFoundProd = products.find(x => x.productid === this.productInfo.productid)
      // if (getFoundProd) {
      //   var totalQty = 0
      //   var receivedCount = 0
      //   if (pickedQty) {
      //     totalQty += pickedQty
      //   }
      //   let orderedQty = this.$format.replaceCommaWithDot(getFoundProd.qty)
      //   let getOnStockFromLocation = this.listOfLocations.find(x => x.locationid === this.selectedLocationId)
      //   if (parseFloat(orderedQty) < totalQty || (getOnStockFromLocation && getOnStockFromLocation.on_stock < totalQty)) {
      //     totalQty = parseFloat(orderedQty) - parseFloat(receivedCount)
      //     totalQty = getOnStockFromLocation.on_stock < totalQty ? getOnStockFromLocation.on_stock : totalQty
      //     this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.qtyExceeds') })
      //     setTimeout(() => {
      //       this.pickQty = totalQty
      //     })
      //   }
      //   if (this.productInfo.isbatch) this.checkIfBatchContainsQty()
      // }
    }
  },
  methods: {
    getOrderInfo () {
      let model = {
        'expand': [{
          'select': ['name'],
          'model': 'Warehouse',
          'on_field': 'id',
          'on_parent_field': 'warehouseid'
        }],
        'filter': `id eq '${this.orderId}'`
      }
      this.$api.execute('post', 'warehouseorders/query', model)
        .then((response) => {
          if (response.data) {
            this.orderModel = response.data[0]
          }
        })
    },
    getAvailableLocationsHandler (productid) {
      this.loadingLocation = true
      this.$api.execute('get', `/stocks/get_warehouse_locations_with_stock?product_id=${productid}&warehouse_id=${this.orderModel.warehouseid}`)
        .then((result) => {
          let model = result.data
          this.listOfLocations = model
          this.loadingLocation = false
        })
    },
    getOrderProducts () {
      this.loading = true
      this.$api.execute('get', `/warehouseorderitems/get_by_order_pwa/${this.orderId}`)
        .then((response) => {
          this.listOfProducts = []
          if (response.data) {
            let products = response.data
            if (products) {
              this.listOfProducts = products.filter(x => !x.receivedqty)
            }
            this.restorePreset()
            this.productInfo = {}
            this.scanProduct = ''
            this.productFound = false
            this.focusField('scanProduct')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getRespectiveProductOrder () {
      this.selectedLocation = ''
      if (this.scanProduct) {
        this.productLoading = true
        let list = this.$format.cloneVariable(this.listOfProducts)
        this.selectedLocationId = 0
        this.isNewProduct = false
        this.productInfo = {}
        if (list) {
          let scanedLower = this.scanProduct.toLowerCase()
          let getProduct = list.find(x => (x.barcode || '').toLowerCase() === scanedLower || (x.productnumber || '').toLowerCase() === scanedLower || (x.productnumberbarcode || '').toLowerCase() === scanedLower)
          if (getProduct) {
            this.productFound = true
            this.productInfo = getProduct
            setTimeout(() => {
              this.pickQty = getProduct.qty
              this.focusField('scanLocation')
            })
            this.getAvailableLocationsHandler(getProduct.productid)
          } else {
            this.selectedLocationId = 0
            const product = await this.getProductByNumber()
            if (product.data && product.data[0]) {
              this.productFound = true
              product.data[0].isbatch = product.data[0].batchrequired
              product.data[0].productid = product.data[0].id
              this.productInfo = product.data[0]
              this.isNewProduct = true
              this.getAvailableLocationsHandler(product.data[0].id)
            } else {
              this.productInfo = {}
              this.productFound = false
              this.$root.$emit('snackbar', { snackbar: true, color: 'info', text: this.$t('message.product.noProductFound') })
              this.focusField('scanProduct')
              this.scanProduct = ''
            }
          }
          this.restorePreset()
          this.productLoading = false
        }
      }
    },
    receiveQtyOnOrder () {
      let pickedQty = this.$format.replaceCommaWithDot(this.pickQty || 0)
      if (this.$refs.receiveForm.validate()) {
        this.saveLoading = true
        let locationid = this.selectedLocationId || 0
        let products = this.$format.cloneVariable(this.listOfProducts)
        let model = products.find(x => x.productid === this.productInfo.productid)
        if (!model) model = {}
        if (!model.receivedorders) model.receivedorders = []
        if (!model.adjustorder) model.adjustorder = {}
        model.adjustorder.locationid = locationid
        model.locationid = locationid
        model.receivedqty = pickedQty
        model.qty = pickedQty
        model.adjustorder.batchnumber = this.selectBatch || ''
        model.productid = this.productInfo.productid
        if (this.isNewProduct) products.push(model)
        if (locationid) {
          let modelObj = { 'items': products }
          this.$api.execute('post', `/warehouseorderitems/bulk_save_pwa/${this.orderId}/${this.isNewProduct}`, modelObj)
            .then((response) => {
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
              if (response.data && response.data.status === 'received') this.$router.push('/adjustment_orders')
              else this.getOrderProducts()
            })
            .finally(() => {
              this.saveLoading = false
            })
        } else {
          this.saveLoading = false
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
        }
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      }
    },
    checkIfBatchContainsQty () {
      let pickedQty = parseFloat(this.$format.replaceCommaWithDot(this.pickQty || 0))
      if (this.selectBatch && pickedQty < 0) {
        let getObj = this.listOfBatchNumbers.find(x => x.batchnumber === this.selectBatch)
        if (getObj) {
          // if (getObj.onstock < pickedQty) {
          //   this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.qtyExceeds') })
          //   setTimeout(() => {
          //     this.pickQty = ''
          //   })
          // }
        } else {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.order.notValidBatch') })
          setTimeout(() => {
            this.selectBatch = ''
          })
        }
      }
    },
    completeAdjustmentOrder () {
      this.completeLoading = true
      this.$api.execute('post', `/warehouseorderitems/complete_adjustment_order/${this.orderId}`)
        .then((response) => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
          this.$router.push('/adjustment_orders')
        })
        .finally(() => {
          this.completeLoading = false
        })
    },
    getProductByNumber () {
      let model = {
        'filter': `number eq '${this.scanProduct}' OR barcode eq '${this.scanProduct}'`,
        'additionalfilters': [`isactive eq 1 AND ispackage ne 1`],
        'skip': 0,
        'limit': 50,
        'order_by': {
          'field': 'number',
          'asc_or_desc': 'asc'
        }
      }
      return this.$api.execute('post', 'products/query', model)
    },
    onResizeHandler () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight - 40 }
    },
    decreaseQty () {
      if (this.pickQty > 0) this.pickQty--
    },
    increaseQty () {
      if (this.pickQty < 0) this.pickQty = ''
      this.pickQty++
    },
    checkIfLocationValid () {
      this.loadingLocation = true
      let locations = this.listOfLocations
      let getOnStockValue = locations.find(x => x.location_name === this.selectedLocation)
      if (getOnStockValue) {
        this.selectedLocationId = getOnStockValue.locationid
        if (this.productInfo.isbatch) this.getBatchNumbersByLocation(this.selectedLocationId)
      } else {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.product.noLocFound') })
        setTimeout(() => {
          this.selectedLocation = ''
          this.selectedLocationId = 0
          this.focusField('scanLocation')
        })
      }
      this.loadingLocation = false
    },
    getBatchNumbersByLocation (locationid) {
      this.loadingBatch = true
      this.$api.execute('get', `warehouseorderitems/get_batchnumbers_by_location?product_id=${this.productInfo.productid}&location_id=${locationid}`)
        .then((result) => {
          let model = result.data
          this.listOfBatchNumbers = model
          this.loadingBatch = false
        })
    },
    focusField (value) {
      requestAnimationFrame(() => {
        if (this.$refs[value]) {
          this.$refs[value].focus()
        }
      })
    },
    restorePreset () {
      this.selectBatch = ''
      this.pickQty = ''
      this.selectedLocation = ''
      this.selectedLocationId = 0
    }
  }
}
</script>
